import type {EstablishedAhpSession} from '@github-ui/ahp-session-client/contracts'
import type {McpPermissionMode} from '@github-ui/agent-sessions-types/mcp-permission-mode'
import type {AgentMode} from '@github-ui/copilot-shared-ui/utils/agent-mode'

import {mapMcpPermissionModeToAgentMode} from '../utils/mcp-permission-mode'

export function resolveEnvironmentTaskStartupMode(
  agentMode: AgentMode | undefined,
  mcpPermissionMode: McpPermissionMode | undefined,
): AgentMode | undefined {
  return agentMode ?? mapMcpPermissionModeToAgentMode(mcpPermissionMode)
}

export async function applyEnvironmentTaskStartupMode(
  session: EstablishedAhpSession,
  mode: AgentMode | undefined,
): Promise<void> {
  if (!mode) return
  await Promise.all([session.commands.setMode(mode), session.commands.setApproveAll(mode === 'autopilot')])
}
